import React from 'react';

function Footer() {
  return (
    <div className="h-70 w-full fixed bottom-0 bg-skin-navbar">
      <p className="text-slate-100 text-center">
        &#169; Images are subjected to copyright
      </p>
    </div>
  );
}

export default Footer;
